// 

import { useState } from "react";
import card1 from "./assets/card1.jpg";
import card2 from "./assets/card2.jpg";
import card3 from "./assets/card3.jpg";
import "./Card.css";


const cards = [
  {
    id: 1,
    title: "Jute Bag",
    description: "High quality, Reliable and Made with care and precision.",
    image: card1,
  },
  {
    id: 2,
    title: "Jute Bag",
    description: "High quality, Reliable and Made with care and precision.",
    image: card2,
  },
  {
    id: 3,
    title: "Jute Bag",
    description: "High quality, Reliable and Made with care and precision.",
    image: card3,
  },
];

function App() {
  const [selectedCard, setSelectedCard] = useState(null);

  return (
    <div style={{ padding: "40px", fontFamily: "Arial" }}>
      <h3 style={{ textAlign: "center" }}>Some Of Our Products</h3>

      <div className="cards-grid">
        {cards.map((card) => (
          <div
            key={card.id}
            className="card"
            onClick={() => setSelectedCard(card)}
          >
            <img
              src={card.image}
              alt={card.title}
              className="card-image"
            />

            <div className="card-content">
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </div>
          </div>
        ))}
      </div>

      {/* POPUP */}
      {selectedCard && (
        <div className="popup" onClick={() => setSelectedCard(null)}>
          <div
            className="popup-box"
            onClick={(e) => e.stopPropagation()}
          >
            <img src={selectedCard.image} alt={selectedCard.title} />
            <h2>{selectedCard.title}</h2>
            <p>{selectedCard.description}</p>

            <p className="popup-para">
              At UrbanDel, every product is thoughtfully designed using
              sustainable materials and skilled craftsmanship. We focus on
              durability, elegance, and eco-friendly practices to deliver
              products that reflect care, quality, and conscious living.
            </p>

            <button onClick={() => setSelectedCard(null)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
